// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()

import '@hotwired/turbo-rails'
import '@rails/activestorage'
import 'flowbite'

// A turbo-frame navigation whose response has no matching frame (e.g. an expired
// session redirected to the sign-in page) would otherwise dead-end as "Content
// missing" inside the frame. Promote it to a full-page visit so the user actually
// lands on the page that came back — typically the login screen.
document.addEventListener('turbo:frame-missing', (event) => {
  const { response, visit } = event.detail
  event.preventDefault()
  visit(response.url)
})

//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import '../controllers'
import "./application.css"

import LocalTime from "local-time"
LocalTime.start()

import 'trix'
import '@rails/actiontext'

// Turbo frame navigations don't auto-scroll to top (only full-page visits do).
// When the admin `main-inner` frame finishes loading a new page via link
// navigation (switching sections, following a section link), scroll the window
// back to top so the operator sees the page header — otherwise the scroll
// position from the previous page carries over and the new content can render
// below the fold.
//
// In-place form actions are the exception: Apply / Disregard on the Insights
// queue (and filter changes) redirect back to the same list, so yanking the
// operator to the top on every click is jarring. They should leave the page
// where it is. Form submissions fire `turbo:submit-start` (link clicks don't),
// so we flag a pending submit targeting `main-inner` and skip the scroll on the
// frame-load it produces.
const targetFrameId = (el) =>
  el.getAttribute('data-turbo-frame') || el.closest('turbo-frame')?.id

let skipMainInnerScroll = false

document.addEventListener('turbo:submit-start', (event) => {
  if (targetFrameId(event.target) === 'main-inner') {
    skipMainInnerScroll = true
  }
})

document.addEventListener('turbo:frame-load', (event) => {
  if (event.target.id !== 'main-inner') return
  if (skipMainInnerScroll) {
    skipMainInnerScroll = false
    return
  }
  window.scrollTo({ top: 0, behavior: 'auto' })
})
// import ApexCharts from 'apexcharts';
// window.ApexCharts = ApexCharts;
